module.exports = __webpack_public_path__ + "img/gzz.3f878d21.png";